import { Injectable } from '@angular/core'

@Injectable()
export class GenService{
    private static monthNamesFull:Array<string> = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    private static monthNamesShort:Array<string> = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    private static milliSecsPerDay:number = 24 * 60 * 60 * 1000;
    private static weekStartDay:number = 1; 

    constructor(){
    }

    public static convToDate(_dateJson:any):Date{
        if(typeof _dateJson == "number"){
            if(_dateJson == 0)
                return null;
            return new Date(_dateJson);
        }
        if(typeof _dateJson == "string"){
            return new Date(_dateJson);
        }
        return null;
    }
    
    static getMonthArray():Array<MonthDef>{
        let _retVal:Array<MonthDef> = [];

        for(var i=0;i<GenService.monthNamesFull.length;i++){
            _retVal.push(new MonthDef(i,GenService.monthNamesFull[i]))
        }
        return _retVal;
    }

    static IsValidNumber(_tmpNumber:any){
        return !isNaN(parseFloat(_tmpNumber)) && isFinite(_tmpNumber);
    }
    public static getGUID(): string {
        return (this.S4() + this.S4() + "-" + this.S4() + "-4" + this.S4().substr(0, 3) + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4()).toLowerCase();
    }
    private static S4(): string {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    static getDatesForWeek(_weekNum:number, _year:number):Array<Date>{
        let _dates:Array<Date> = [];
        let _stDate:Date = this.getStartDateOfWeek(_weekNum,_year);
        for(var i=0;i<7;i++){
            let _newDate:Date = new Date(_stDate);
            _newDate.setDate(_stDate.getDate() + i);
            _dates.push(_newDate);
        }
        return _dates;
    }
    static getWeekNumbersForMonth(year:number,month:number):Array<number>{
        let _weekNums:Array<number> = [];
        let _monthStDate = new Date(year,month-1,1);
        let _monthEdDate = new Date(_monthStDate.getFullYear(),_monthStDate.getMonth()+1,0);

        let _weekSt = this.getWeekNum(_monthStDate);
        let _weekEd = this.getWeekNum(_monthEdDate);

        for(var i = _weekSt; i <= _weekEd;i++){
            _weekNums.push(i);
        }

        return _weekNums;
    }
    static getDateNum(_dt:Date):number{
        if(_dt && _dt.getTime()){
          return (_dt.getFullYear() * 10000) + 
                 ((_dt.getMonth() + 1) * 100) + 
                 _dt.getDate();
        }
        return 0;
      }
    static getWeekNum(_date:Date):number{//ISO-8601
        let jan1 = new Date(_date.getFullYear(), 0, 1);
        let dayOffset:number =  this.getDayOffsetOfYear(jan1.getDay());
        //bug fixed by adding overflowing 
        return Math.ceil((((_date.getTime() - jan1.getTime() + 1) / this.milliSecsPerDay) + dayOffset) / 7);
    }
    static getMaxWeekNumForYear(_year:number):number{
        let dec31 = new Date(_year,12,0);
        return GenService.getWeekNum(dec31);
    }
    static getStartDateOfWeek(_weekNum:number, _year:number):Date{
        let jan1 = new Date(_year, 0, 1);
        let dayOffset:number =  this.getDayOffsetOfYear(jan1.getDay());
        jan1.setDate(jan1.getDate() + ((_weekNum -1) * 7) - dayOffset )
        return jan1;
    }
    static getDayNumOfyear(_date:Date):number{
        let jan1 = new Date(_date.getFullYear(), 0, 1);
        let dayOffset:number =  this.getDayOffsetOfYear(jan1.getDay());
        return Math.ceil((((_date.getTime() - jan1.getTime()) / this.milliSecsPerDay) + dayOffset + 1));
    }
    static getDateFormatStr(_date:Date, _format:string):string{
        if(isNaN(_date.getTime()) || _date.getTime() == 0) return "";
        switch(_format){
            case "YYYY":
                return _date.getFullYear() + ''
            case "MMM":
                return this.monthNamesFull[_date.getMonth()]
            case "MMM YYYY":
                return this.monthNamesFull[_date.getMonth()] + ' ' +_date.getFullYear();
            case "DD MMM YYYY":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + ' ' + this.monthNamesFull[_date.getMonth()] + ' ' +_date.getFullYear();
            case "DD-MM-YYYY":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + ((_date.getMonth() + 1) < 10 ? '0' : '') + (_date.getMonth() + 1) + '-' +_date.getFullYear();
            case "DD-MMM-YYYY":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + this.monthNamesFull[_date.getMonth()] + '-' +_date.getFullYear();
            case "DD-mmm-YYYY":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + this.monthNamesShort[_date.getMonth()] + '-' +_date.getFullYear();
            case "DD MMM":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + ' ' + this.monthNamesFull[_date.getMonth()];
            case "DD-MMM":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + this.monthNamesFull[_date.getMonth()];
            case "DD-mmm":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + this.monthNamesShort[_date.getMonth()];
            case "DD/MMM/YY HH:mm:ss":
                return this.prepZeros(_date.getDate(),2) + '-' + this.monthNamesShort[_date.getMonth()] + '-' 
                      + (_date.getFullYear() % 100) + ' ' + this.prepZeros(_date.getHours(),2) + ':' 
                      + this.prepZeros(_date.getMinutes(), 2) + ':' + this.prepZeros(_date.getSeconds(), 2);
            case "MMMM-YYYY":
                return this.monthNamesFull[_date.getMonth()] + '-' +_date.getFullYear();
            case "MMM-YYYY":
                return this.monthNamesShort[_date.getMonth()] + '-' +_date.getFullYear();            
            case "YYYYMMDD":
                return _date.getFullYear() + '' + ((_date.getMonth() + 1) < 10 ? '0' : '') + (_date.getMonth()+1) +
                       (_date.getDate() < 10 ? '0' : '')+ _date.getDate();
            case "YYYYMM":
                       return _date.getFullYear() + '' + ((_date.getMonth() + 1) < 10 ? '0' : '') + (_date.getMonth()+1);
        }
        return "-";
    }

    static parseDateString(_dateStr:string, _format:string):Date{
        _dateStr += '';
        switch(_format){
            case "YYYYMMDD":
                if(_dateStr.length == 8){
                    return new Date(parseInt(_dateStr.substring(0,4),10),
                                    parseInt(_dateStr.substring(4,6),10) - 1,
                                    parseInt(_dateStr.substring(6,8),10));
                }
                break;
        }
        return null;
    }
    private static prepZeros(_number:number,_reqNoOfDigits:number):string{
        let _retVal = _number + '';
        while(_retVal.length < _reqNoOfDigits){
            _retVal = '0' + _retVal;
        }
        return _retVal;
    }
    private static getDayOffsetOfYear(_dayofWeek:number):number{
        switch(_dayofWeek){
            case 0: return -1;
            case 1: return 0;
            case 2: return 1;
            case 3: return 2;
            case 4: return 3;
            case 5: return -3;
            case 6: return -2;
        }
        return 0;
    }
}

export class MonthDef{
    constructor(private _monthIndex:number,private _monthName:string){

    }

    get monthIndex():number{
        return this._monthIndex;
    }
    get monthName():string{
        return this._monthName;
    }
}
